import React, { useEffect, useState, useRef } from "react";
import classes from "./MemberCollections.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import api, { BASE_URL, getAuthHeaders } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import MemberCollectionsModal from "./SavingModal/MemberCollectionsModal";


const MemberCollections = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);
  const printRef = useRef();
  const [openCashReciept, setOpenCashReciept] = useState(false);
  
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/v1/fetch-purchases-invoice`, {
  //         headers: getAuthHeaders(),
  //       });
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

useEffect(() => {
  fetchInvoices();
}, []);

const fetchInvoices = async (page = 1) => {
  try {
    setLoading(true);

    const res = await api.get(
      `/v1/account/fetch-all-members-savings-transactions?page=${page}`
    );

    const savings = res.data?.data?.savings;

    if (savings?.data) {
      setInvoices(savings.data);

      setCurrentPage(savings.current_page);
      setLastPage(savings.last_page);
      setTotal(savings.total);
      setFrom(savings.from || 0);
      setTo(savings.to || 0);
    } else {
      setInvoices([]);
    }
  } catch (err) {
    setInvoices([]);
  } finally {
    setLoading(false);
  }
};

const handlePageChange = (page) => {
  fetchInvoices(page);
};

  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };


  const getDeliveryStatus = (item) => {
    const rawValue = item?.is_supplied ?? item?.delivery_status ?? item?.status;

    if (rawValue == 1 || rawValue === "1") {
      return { text: "delivered", class: classes.greenStatus };
    }
    if (rawValue == 0 || rawValue === "0") {
      return { text: "not delivered", class: classes.yellowStatus };
    }

    return { text: String(rawValue || "not delivered"), class: classes.yellowStatus };
  };
  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/purchase-invoice-matrix");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      }
    };
    fetchMetrics();
  }, []);

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData, pageTitle: "Purchase Invoice" },
    });
  };

  const handleReversePurchaseInvoice = async (item) => {
    // Confirm deletion
    const result = await Swal.fire({
      title: 'Reverse Purchase Invoice',
      text: 'Are you sure you want to reverse this purchase invoice? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, {
        invoice_id: item.id,
        invoice_number: item.invoice_number || item.document_number
      });

      if (response.status === 200 || response.status === 201) {
        // Remove the item from the table
        setInvoices(invoices.filter(invoice => invoice.id !== item.id));
        Swal.fire({
          title: 'Success!',
          text: 'Member collection reversed successfully.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Failed to reverse invoice:", error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing purchase invoice. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      });
    }
  };




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Member Collections</h2>
          <h1 className={classes.Titles}>
            View and Manage Collections.
          </h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Purchase</p>
                <p className={classes.kdptg1}>{selectMetrics?.total_purchase?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Outstanding</p>
                <p className={classes.kdptg2}>{selectMetrics?.outstanding?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>{selectMetrics?.total_invoices?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search savings" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <button className={classes.btnss} 
          // onClick={() => 
          // navigate("/transactions/purchase-invoice/purchase/new-item")}
          onClick={() => setOpenCashReciept(true)}
          > 
          + New Collections</button>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Reference</th>
                  <th>Member Number</th>
                  <th>Transaction Date</th>
                  <th>Description</th>
                  <th>Credit</th>
                  <th>Debit</th>
                  <th>Balance</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(10)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No member collections found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                      <tr key={item.id}>
                        <td>{from + index}</td>

                        <td>{item.uuid}</td>

                        <td>{item.member_number}</td>

                        <td>{item.transaction_date}</td>

                        <td>{item.description}</td>

                        <td style={{ textAlign: "right" }}>
                          {Number(item.credit).toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                          })}
                        </td>

                        <td style={{ textAlign: "right" }}>
                          {Number(item.debit).toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                          })}
                        </td>

                        <td style={{ textAlign: "right" }}>
                          {Number(item.balance).toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                          })}
                        </td>

                        <td>
                          {item.status === "1" ? (
                            <span className={classes.greenStatus}>
                              Active
                            </span>
                          ) : (
                            <span className={classes.redStatus}>
                              Inactive
                            </span>
                          )}
                        </td>
                        <td className={classes.actions}>
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 
                            size={16} 
                            className={classes.deleteIcon}
                            onClick={() => handleReversePurchaseInvoice(item)}
                            style={{ cursor: "pointer" }}
                          />
                          <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>

              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(1)}
              >
                First
              </button>

              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Prev
              </button>

              {Array.from({ length: lastPage }, (_, i) => (
                <button
                  key={i}
                  className={
                    currentPage === i + 1
                      ? classes.active
                      : ""
                  }
                  onClick={() =>
                    handlePageChange(i + 1)
                  }
                >
                  {i + 1}
                </button>
              ))}

              <button
                disabled={currentPage === lastPage}
                onClick={() =>
                  handlePageChange(currentPage + 1)
                }
              >
                Next
              </button>

              <button
                disabled={currentPage === lastPage}
                onClick={() =>
                  handlePageChange(lastPage)
                }
              >
                Last
              </button>

              <span className={classes.pageText}>
                Displaying {from} - {to} of {total}
              </span>

            </div>
          </div>

        </div>
      </div>

      <MemberCollectionsModal
        isOpen={openCashReciept}
        onClose={() => setOpenCashReciept(false)}
        onSuccess={() => {
          fetchInvoices(currentPage); // reload table
          setOpenCashReciept(false);  // close modal
        }}
      />

      {/* <MemberCollectionsModal isOpen={openCashReciept} onClose={() => setOpenCashReciept(false)} 

      // onSuccess={handlePaymentSuccess} 
      /> */}
      <Footer />
    </div>
  );
};

export default MemberCollections;
